import { Button, ButtonBar, ProfileIcon, UserIcon } from '@ygtechnologies/bygr-frontend-component-library';
import React, { useState } from 'react';
import theme from './LinkProjectModal.module.scss';
import { memberSort } from './LinkProjectSelectUsers';
import { LinkProjectData } from './LinkProjectModal';

interface LinkProjectSummaryProps {
    projectData: LinkProjectData;
    onSave(): Promise<void>;
    onCancel(): void;
    onBack(): void;
}

const LinkProjectSummary: React.FC<LinkProjectSummaryProps> = ({ projectData, onSave, onCancel, onBack }) => {
    const [isSaving, setIsSaving] = useState<boolean>(false);

    const handleSave = async () => {
        setIsSaving(true);
        await onSave();
        setIsSaving(false);
    };

    return (
        <div>
            <h1>Responsible profile</h1>
            <div className={theme.selectButton}>
                <ProfileIcon profileIconUrl="" sizeInPx={36} className={theme.companyImg} />
                {projectData.sellerProfileName}
            </div>

            <h1>Members</h1>
            <ul className={theme.list}>
                {projectData.members.sort(memberSort).map((member) => (
                    <li key={member.userId}>
                        <div className={theme.participantWrapper}>
                            <ProfileIcon profileIconUrl="" sizeInPx={36} className={theme.companyIcon} />
                            <div className={theme.icons}>
                                <UserIcon avatarThumbnailUrl="" sizeInPx={24} className={theme.employeeIcon} />
                            </div>
                            <div className={theme.userInfo}>
                                <div>{member.userName}</div>
                                <div className={theme.companyRole}>{member.email}</div>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>

            <ButtonBar>
                <Button onClick={onCancel} color="tertiary">
                    Cancel
                </Button>
                <Button onClick={onBack} color="tertiary">
                    Back
                </Button>
                <Button onClick={handleSave} loading={isSaving} color="primary">
                    Create
                </Button>
            </ButtonBar>
        </div>
    );
};

export default LinkProjectSummary;
